import { BottleBeer as o } from "./bottle-beer.js";
import { Beer as r } from "./beer.js";
import { Coffee2 as m } from "./coffee-2.js";
import { Drink as i } from "./drink.js";
import { Drinks as t } from "./drinks.js";
import { Bottle as p } from "./bottle.js";
import { Wine as f } from "./wine.js";
import { CocktailMojito as e } from "./cocktail-mojito.js";
import { CocktailVodkaLime as a } from "./cocktail-vodkalime.js";
import { CocktailGinTonic as n } from "./cocktail-gintonic.js";
import { Cocktail as l } from "./cocktail.js";
import { Food as k } from "./food.js";
import { Apple as c } from "./apple.js";
import { Salad as d } from "./salad.js";
import { Donut as C } from "./donut.js";
import { RiceBowl as B } from "./rice-bowl.js";
import { Watermelon as D } from "./watermelon.js";
import { Lemon as s } from "./lemon.js";
import { Pudding as u } from "./pudding.js";
import { IceCream as z } from "./ice-cream.js";
import { BirthdayCake as A } from "./birthday-cake.js";
import { Pizza as F } from "./pizza.js";
import { Qsr as L } from "./qsr.js";
const N = {
  BottleBeer: o,
  Beer: r,
  Coffee2: m,
  Drink: i,
  Drinks: t,
  Bottle: p,
  Wine: f,
  CocktailMojito: e,
  CocktailVodkaLime: a,
  CocktailGinTonic: n,
  Cocktail: l,
  Food: k,
  Apple: c,
  Salad: d,
  Donut: C,
  RiceBowl: B,
  Watermelon: D,
  Lemon: s,
  Pudding: u,
  IceCream: z,
  BirthdayCake: A,
  Pizza: F,
  Qsr: L
};
export {
  N as FoodAndDrink
};
